module.exports = __webpack_public_path__ + "img/building9.7bf16676.jpg";